import styled from 'styled-components'

import { _XS_Normal, mainColors, semanticColors } from '@avantstay/backoffice-core'

export const Caption = styled.span.attrs({ 'aria-live': 'polite' })<{ $isFailed?: boolean }>`
  ${_XS_Normal};

  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  overflow-wrap: anywhere;
  color: ${({ $isFailed }) => {
    return $isFailed ? semanticColors.failureDark : mainColors.neutralExtremelyDark
  }};

  svg {
    flex: none;
    width: 16px;
    height: 16px;
  }
`

export const FailedLabel = styled.span`
  cursor: help;
  text-decoration: underline dotted;
  text-underline-offset: 2px;
  border-radius: 2px;

  &:focus-visible {
    outline: 2px solid ${semanticColors.failureMedium};
    outline-offset: 2px;
  }
`
